import { Flex } from '@/components/layouting';
import type { CSSProperties, FC, ReactNode } from 'react';

interface AuthContentLayoutProps {
  alert?: ReactNode;
  paragraph?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  gap?: number;
  style?: CSSProperties;
}

export const AuthContentLayout: FC<AuthContentLayoutProps> = ({ alert, paragraph, actions, children, style }) => {
  return (
    <Flex vertical gap={24} style={style}>
      {alert}
      {paragraph}
      {children}
      {actions}
    </Flex>
  );
};
